import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import debounce from "lodash/debounce";
import CarouselNavigation from "../CarouselNavigation/CarouselNavigation";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import { Provider as CurrentCardsVisibleProvider } from "../../currentCardsVisibleContext";
var initialCardsTwo = 2;
var initialCardsThree = 3;
var resizeDebounceTimeout = 200;
var translateStep = 100;

var Carousel = /*#__PURE__*/function (_Component) {
  _inherits(Carousel, _Component);

  var _super = _createSuper(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(Carousel.displayName));

    _defineProperty(_assertThisInitialized(_this), "validChildren", function () {
      return React.Children.toArray(_this.props.children).filter(function (child) {
        return /*#__PURE__*/React.isValidElement(child);
      }).length;
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", debounce(function () {
      var windowWidth = window.innerWidth;
      var breakPoint = 768; // At breakPoint reset carousel

      if (windowWidth < breakPoint) {
        _this.setNumberCardsVisible(1);

        _this.createPaginationArray(); // Only reset Carousel states if in mobile state

      } else if (_this.state.numberCardsVisible === 1 && !_this.props.intro) {
        _this.setNumberCardsVisible(initialCardsThree);

        _this.createPaginationArray();
      } else if (_this.state.numberCardsVisible === 1 && _this.props.intro) {
        _this.setNumberCardsVisible(initialCardsTwo);

        _this.createPaginationArray();
      }
    }, resizeDebounceTimeout));

    _defineProperty(_assertThisInitialized(_this), "setNumberCardsVisible", function (numberCards) {
      _this.setState({
        numberCardsVisible: numberCards,
        pageIndex: 1,
        numberPages: Math.ceil(_this.validChildren() / numberCards),
        translatePosition: 0,
        previousVisible: false,
        nextVisible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "nextSlide", function () {
      _this.setState(function (prevState) {
        var newState = {}; // If there are more pages to show, translate track to next page and iterate page index

        if (_this.state.pageIndex !== _this.state.numberPages) {
          newState.translatePosition = prevState.translatePosition - translateStep;
          newState.pageIndex = prevState.pageIndex + 1;
        } // If translating to last page remove next arrow


        if (_this.state.numberPages - _this.state.pageIndex === 1) {
          newState.nextVisible = !prevState.nextVisible;
        } // If previous arrow is hidden, show it


        if (_this.state.previousVisible === false) {
          newState.previousVisible = !prevState.previousVisible;
        }

        return newState;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "previousSlide", function () {
      _this.setState(function (prevState) {
        var newState = {}; // If not on first page, translate track to previous page, and iterate page index

        if (_this.state.pageIndex > 1) {
          newState.translatePosition = prevState.translatePosition + translateStep;
          newState.pageIndex = prevState.pageIndex - 1;
        } // If translating track from last page, show next arrow


        if (_this.state.numberPages === _this.state.pageIndex) {
          newState.nextVisible = !prevState.nextVisible;
        } // If translating track to first page, remove previous arrow


        if (_this.state.pageIndex === initialCardsTwo) {
          newState.previousVisible = !prevState.previousVisible;
        }

        return newState;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createPaginationArray", function () {
      var emptyArray = Array(_this.state.numberPages);
      var paginationArray = [];

      var _iterator = _createForOfIteratorHelper(Array.apply(void 0, emptyArray).entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 1),
              index = _step$value[0];

          paginationArray.push(index);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      _this.setState({
        paginationArray: paginationArray
      });
    });

    _this.validChildren = _this.validChildren.bind(_assertThisInitialized(_this));
    var initialCards = _this.props.intro ? initialCardsTwo : initialCardsThree;
    _this.state = {
      translatePosition: 0,
      pageIndex: 1,
      numberPages: Math.ceil(_this.validChildren() / initialCards),
      numberCardsVisible: initialCards,
      nextVisible: true,
      previousVisible: false,
      paginationArray: []
    };
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createPaginationArray();
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          intro = _this$props.intro;
      return /*#__PURE__*/React.createElement(CurrentCardsVisibleProvider, {
        value: this.state.numberCardsVisible
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName(),
        "data-rehydratable": getRehydratableName(Carousel.displayName)
      }, intro && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "intro"
        }),
        "data-rehydratable-intro": true
      }, intro), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "inner"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "track"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "trackInner"
        }),
        "data-rehydratable-children": true,
        style: {
          transform: "translate3d(".concat(this.state.translatePosition, "%, 0, 0)")
        }
      }, children)), /*#__PURE__*/React.createElement(CarouselNavigation, {
        nextSlideFunc: this.nextSlide,
        nextVisible: this.state.nextVisible,
        numberPages: this.state.numberPages,
        paginationArray: this.state.paginationArray,
        pageIndex: this.state.pageIndex,
        previousSlideFunc: this.previousSlide,
        previousVisible: this.state.previousVisible
      }))));
    }
  }]);

  return Carousel;
}(Component);

_defineProperty(Carousel, "displayName", "Carousel");

_defineProperty(Carousel, "propTypes", {
  /**
   * Child card nodes
   */
  children: PropTypes.node,

  /**
   * Intro nodes
   */
  intro: PropTypes.node
});

export default Carousel;